<kendo-tabstrip *ngIf="symbols || heatmapMode">
    <kendo-tabstrip-tab *ngIf="pointSymbol" [title]="'Points'" [selected]="firstSymbol === pointSymbol">
        <ng-template kendoTabContent>
            <slot name="point-symbol-editor" #pointSymbolEditor></slot>
            <slot name="layer-opacity-editor" #opacityEditor></slot>
        </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab *ngIf="lineSymbol" [title]="'Lines'" [selected]="firstSymbol === lineSymbol">
        <ng-template kendoTabContent>
            <slot name="line-symbol-editor" #lineSymbolEditor></slot>
            <slot name="layer-opacity-editor" #opacityEditor></slot>
        </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab *ngIf="polygonSymbol" [title]="'Polygons'" [selected]="firstSymbol === polygonSymbol">
        <ng-template kendoTabContent>
            <slot name="polygon-symbol-editor" #polygonSymbolEditor></slot>
            <slot name="layer-opacity-editor" #opacityEditor></slot>
        </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab *ngIf="textSymbol" [title]="'Text'" [selected]="firstSymbol === textSymbol">
        <ng-template kendoTabContent>
            <slot name="text-symbol-editor" #textSymbolEditor></slot>
            <slot name="layer-opacity-editor" #opacityEditor></slot>
        </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab *ngIf="heatmapMode" [title]="'Heatmap'" [selected]="heatmapRenderer" >
        <ng-template kendoTabContent>
            <slot name="heatmap-editor" #heatmapEditor></slot>
            <slot name="layer-opacity-editor" #opacityEditor></slot>
        </ng-template>
    </kendo-tabstrip-tab>
</kendo-tabstrip>
<div class="text-right">
    <button type="button" class="btn" (click)="apply()">OK</button>
    <button type="button" class="btn btn-clear" (click)="cancel()">Cancel</button>
</div>
